export const SET_ELE_TEAM_LOADING = 'SET_ELE_TEAM_LOADING'
export const SET_ELE_TEAM = 'SET_ELE_TEAM'